<template>
  <v-container fluid>
    <v-layout class="mb-5" align-start justify-left wrap>
      <v-flex d-flex xs12 sm4 md3 v-if="!state.isLoadedOrNotInit()"  class="mb-5">
        <v-card min-width="90%">
          <v-card-text>
            <loading-state :state="state"></loading-state>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm4 md3 v-for="account in accounts" :key="account.key"  class="mb-5">
        <account-item :account="account"></account-item>
      </v-flex>
      <v-flex  class="mb-5">
        <v-card color="#385F73" dark width="300">
          <v-card-text class="white--text">
            <div class="headline mb-2">Create new account</div>
            Create account to maintain balances and expenses seperately
          </v-card-text>

          <v-card-actions>
            <v-dialog v-model="showCreateDailog" max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on">Create</v-btn>
              </template>
              <create-account 
                @created="onAccountCreated"
                v-model="showCreateDailog"></create-account>
            </v-dialog>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { DataState } from "@/state"
import { Account } from "@/models/account"
import CreateAccount from "@/components/CreateAccount";
import AccountItem from "@/components/AccountItem";
export default {
  components: {
    CreateAccount: CreateAccount,
    AccountItem: AccountItem
  },
  data() {
    return {
      accounts: [],
      showCreateDailog: false,
      state: DataState.newLoading(),
      createState: DataState.newLoading(),
    };
  },

  mounted () {
    this.onLoaded()
  },

  methods: {
    onLoaded () {
      this.state.changeToLoading()
      Account.list(true).then((response) => {
        this.accounts = response
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
    onAccountCreated(account) {
      this.accounts.push(account)
      this.showCreateDailog = false
    }
  }
};
</script>
